export default "__VITE_ASSET__C6zGl01p__"